import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Lock } from '@/entity/Lock';
import { useUserDataStore } from '@/store/userData';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'lockList',
  setup(__props) {
    const router = useRouter();
    const userData = useUserDataStore();
    userData.init();
    var list = ref(userData.lockList.map(lock => Lock.fromUrl(lock)));
    function detailClick(lock) {
      router.push("/lockDetail/" + lock.toString(true));
    }
    function removeClick(lock) {
      userData.removeLock(lock);
      list.value = userData.lockList.map(lock => Lock.fromUrl(lock));
    }
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createBlock(_component_el_table, {
        data: _unref(list),
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "label",
          label: "标签"
        }), _createVNode(_component_el_table_column, {
          prop: "D_Mac",
          label: "MAC"
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Operations",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => detailClick(row)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => removeClick(row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]);
    };
  }
};